import { HiOutlinePlusSmall } from 'react-icons/hi2';
import { useShallow } from 'zustand/react/shallow';

import EmptyStateCTA from '@src/assets/images/EmptyStateCTA.svg';
import { OButton, OResponsiveModal } from '@src/shared';
import { useCtaStore } from '@src/stores';

import styles from './ctaManagementModal.module.scss';

const CTAManagementModal = () => {
  const { ctas, setIsCreateCtaModalOpen, isCtaManagementModalOpen, setIsCtaManagementModalOpen } = useCtaStore(
    useShallow((state) => ({
      ctas: state.ctas,
      setIsCreateCtaModalOpen: state.setIsCreateCtaModalOpen,
      isCtaManagementModalOpen: state.isCtaManagementModalOpen,
      setIsCtaManagementModalOpen: state.setIsCtaManagementModalOpen,
    }))
  );

  // Keep the "empty vs table" decision inside the modal (we'll handle the CTA table here in the future)
  const hasCTAs = ctas.length > 0;

  const handleAddNew = () => {
    // UI flow only (no BE integration yet)
    setIsCtaManagementModalOpen(false);
    setIsCreateCtaModalOpen(true);
  };

  return (
    <OResponsiveModal
      isOpen={isCtaManagementModalOpen}
      onClose={() => setIsCtaManagementModalOpen(false)}
      title="CTA Management"
      modalClasses={{
        title: styles.ctaModalTitle,
        container: styles.ctaModalContainer,
        body: styles.ctaModalBody,
        closeIconWrapper: styles.modalCloseIconWrapper,
      }}
      hasBackdrop={true}
    >
      {!hasCTAs ? (
        <div className={styles.ctaModalContent}>
          <img
            src={EmptyStateCTA}
            alt="cta-empty-state"
            className={styles.ctaEmptyImage}
            loading="eager"
            decoding="sync"
          />

          <div className={styles.ctaInfo}>
            <h2 className={styles.ctaContentTitle}>No CTAs Yet</h2>
            <p className={styles.noCtaDesc}>
              You haven’t created any CTAs for this session. Create one to engage your audience with links, media, or QR
              codes.
            </p>
          </div>
          <OButton onClick={handleAddNew} startIcon={<HiOutlinePlusSmall />} text="Add new" size="large" />
        </div>
      ) : (
        <></>
      )}
    </OResponsiveModal>
  );
};

export default CTAManagementModal;
